import React, {
  createContext, useCallback, useContext, useMemo,
} from 'react';

import usePersistedState from 'hooks/usePersistedState';
import { useHistory } from 'react-router-dom';
import useHomePath from 'hooks/useHomePath';

const RedirectContext = createContext({});
function RedirectProvider(props) {
  const [path, setPath] = usePersistedState(null, {
    key: 'redirect-provider/path',
    ttl: 1000 * 60 * 50,
  });
  const history = useHistory();
  const homePath = useHomePath();
  const clear = useCallback(() => {
    setPath(null);
  }, []);
  const saveRedirectPath = useCallback((redirectPath) => {
    setPath(redirectPath || history.location.pathname);
  }, []);

  const redirect = useCallback(() => {
    setTimeout(() => {
      history.replace(path || homePath);
    }, 10);
    clear();
  }, [path, homePath]);

  const contextValue = useMemo(() => ({
    clear,
    saveRedirectPath,
    redirect,
  }), [clear, saveRedirectPath, redirect]);

  return <RedirectContext.Provider {...props} value={contextValue} />;
}

RedirectProvider.useRedirect = () => useContext(RedirectContext);
export default RedirectProvider;
